import trim from 'lodash/fp/trim';
import noop from 'lodash/fp/noop';

import classNames from 'classnames';

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import { validateHwSerial } from '~/features/base/utils/hwSerialValidator';

export class SerialNumberFormItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isValid: props.value ? validateHwSerial(props.value) : true,
        };
        this.onChange = this.onChange.bind(this);

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!prevState.focused) {
            return {
                isValid: nextProps.value ? validateHwSerial(nextProps.value) : true,
            };
        }
        return prevState;
    }

    onChange(event) {
        const hwSerial = trim(event.target.value);
        const isValid = hwSerial ? validateHwSerial(hwSerial) : true;
        this.setState({
            isValid,
        });
        this.props.onChange({
            serialNumber: hwSerial || undefined,
        });
    }

    render() {
        const { label, value } = this.props;
        const { isValid } = this.state;

        const helpBlockMessage = !isValid ?
            <FormattedMessage id='intl-msg:invalidSerialNumber'/> : undefined;

        return (
            <div className={classNames('form-group', { 'has-error': !isValid })}>
                <label className='control-label'>
                    <FormattedMessage id={label}/>
                </label>
                <span className='input-group width-100pct'>
                    <span className='input-group-addon'>
                        <span className='rioglyph rioglyph-search' aria-hidden='true'></span>
                    </span>
                    <FormattedMessage id='intl-msg:serialNumber.prompt'>
                        { placeHolder =>
                            <input className='form-control'
                                type='text'
                                value={value}
                                placeholder={placeHolder}
                                onChange={this.onChange}/>
                        }
                    </FormattedMessage>
                </span>
                <span className='help-block'>{helpBlockMessage}</span>
            </div>

        );
    }
}

export default SerialNumberFormItem;

// TODO Obviously it doesn't work without knowledge about whitelistingInfo
SerialNumberFormItem.defaultProps = {
    // props
    value: '',
    label: 'intl-msg:serialNumber',
    // functions
    onChange: noop,
};

SerialNumberFormItem.propTypes = {
    // props
    value: PropTypes.string,
    label: PropTypes.string,
    // functions
    onChange: PropTypes.func,
};
